import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { colors, spacing, shadows } from '../theme/index';

function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const txnid = searchParams.get('txnid');
  const orderId = searchParams.get('orderId');
  const mihpayid = searchParams.get('mihpayid');

  useEffect(() => {
    // Redirect to order confirmation after 3 seconds
    const timer = setTimeout(() => {
      if (orderId) {
        navigate('/order-confirmation/' + orderId);
      } else {
        navigate('/orders');
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, [orderId, navigate]);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: colors.background, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: spacing.xl }}>
      <motion.div
        style={{
          backgroundColor: 'white',
          borderRadius: '1rem',
          padding: spacing.xl,
          boxShadow: shadows.lg,
          maxWidth: '420px',
          width: '100%',
          textAlign: 'center',
        }}
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
      >
        <motion.div
          style={{ fontSize: '5rem', marginBottom: spacing.lg }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 200, delay: 0.1 }}
        >
          🎉
        </motion.div>
        <h2 style={{ fontSize: '1.75rem', fontWeight: 900, color: colors.success, margin: 0, marginBottom: spacing.sm }}>
          Payment Successful!
        </h2>
        <p style={{ fontSize: '1rem', color: colors.text.secondary, marginBottom: spacing.lg }}>
          Your payment has been processed successfully.
        </p>

        {orderId && (
          <div style={{ padding: spacing.md, backgroundColor: colors.primary[25], borderRadius: '0.5rem', marginBottom: spacing.lg }}>
            <p style={{ margin: 0, fontSize: '0.9rem', color: colors.primary[700] }}>
              <strong>Order ID:</strong> #{orderId}
            </p>
            {mihpayid && (
              <p style={{ margin: `${spacing.xs} 0 0`, fontSize: '0.85rem', color: colors.primary[600] }}>
                <strong>PayU Reference:</strong> {mihpayid}
              </p>
            )}
          </div>
        )}

        <motion.div 
          animate={{ opacity: [1, 0.5, 1] }} 
          transition={{ duration: 1.5, repeat: Infinity }}
          style={{ fontSize: '0.9rem', color: colors.text.secondary }}
        >
          Redirecting to order details...
        </motion.div>

        <motion.button
          onClick={() => navigate(orderId ? '/order-confirmation/' + orderId : '/orders')}
          style={{
            width: '100%',
            padding: spacing.lg,
            backgroundColor: colors.primary[600],
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            fontWeight: 700,
            fontSize: '1rem',
            cursor: 'pointer',
            marginTop: spacing.lg,
          }}
          whileHover={{ backgroundColor: colors.primary[700] }}
          whileTap={{ scale: 0.95 }}
        >
          View Order Details
        </motion.button>
      </motion.div>
    </div>
  );
}

export default PaymentSuccess;